import { Selector } from 'Shared/backend/widgets/Margins';
import { ColourPicker } from 'Shared/forms/ColourPicker';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';

export function Colour()
{
	return (<>
		<Selector/>

		<LabelOnLeftWrap label='Colour' narrow={true}>
			<ColourPicker field='colour' />
		</LabelOnLeftWrap>
	</>);
}

